import { Model } from 'libx';

export default class Code extends Model {

}



// WEBPACK FOOTER //
// ./src/models/Code.js